export default "__VITE_ASSET__c3a4005e__"